import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {Swiper} from 'swiper'
import {FreeMode, Navigation} from 'swiper/modules'
import {elementsToMaxHeight} from '../utils/elements-to-max-sizes'
import {breakpointDown, breakpointUp, getScreenHeight, pxToRem, pxToScreenSize} from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)

let swiperEl;

const initClientReviewCarousel = () => {
  const swiperElement = document.querySelector('.swiper-client-reviews')
  if (!swiperElement) return false

  const clearReviewCarousel = () => {
    if (swiperEl) {
      swiperEl.destroy(true, true); // Destroy Swiper instance
      swiperEl = null; // Set swiper to null
    }
    $('.swiper-client-reviews .card-description, .swiper-client-reviews .card-footer').removeAttr('style');
  }
  clearReviewCarousel();
  if ($(window).width() < 992) {
    elementsToMaxHeight($('.swiper-client-reviews .card-description'))
    elementsToMaxHeight($('.swiper-client-reviews .card-footer'))
    swiperEl = new Swiper('.swiper-client-reviews', {
      modules: [FreeMode, Navigation],
      spaceBetween: 0,
      slidesPerView: 'auto',
      freeMode: {
        enabled: true
      },
      navigation: {
        nextEl: ".swiper-client-reviews-next",
        prevEl: ".swiper-client-reviews-prev",
      },
      loop: true,
    })
  }
}

let clientReviewTl;
const initClientReviewVerticalSlider = () => {
  let block = document.querySelector('.block-client-reviews')
  if (!block) return false
  const clearReviewSlider = () => {
    if (clientReviewTl) {
      ScrollTrigger.getById('clientReview').kill(true)
      gsap.set('.block-client-reviews .vertical-slides', {clearProps: true})
      clientReviewTl.kill(true)
      clientReviewTl = null
    }
  }

  clearReviewSlider();
  if ($(window).width() > 991) {
    let header = block.querySelector('.block-header .h1')
    let cards = block.querySelectorAll('.vertical-slide')

    let headerHeight = header.clientHeight

    let underTitle = (headerHeight / 2) + (getScreenHeight() / 2)

    cards[0].style = `margin-top: ${pxToScreenSize(116)}px`
    // Second card position
    cards[1].style = `margin-top: ${underTitle + pxToScreenSize(92)}px`

    cards[2].style = `margin-top: ${underTitle - headerHeight}px`

    cards[3].style = `margin-top: ${pxToScreenSize(-150)}px`

    // Link card - white one
    cards[4].style = `margin-top: ${headerHeight + pxToScreenSize(92)}px`


    let cardsHeight = block.querySelector('.vertical-slides').clientHeight
    let linkCardHeight = cards[4].clientHeight
    let scrollUpLimit = cardsHeight - (getScreenHeight() / 2) - (linkCardHeight / 2)

    clientReviewTl = gsap.timeline({
      scrollTrigger: {
        id: 'clientReview',
        trigger: '.block-client-reviews',
        pin: true,
        start: 'center center',
        end: '+=120%',
        markers: false,
        scrub: true,

      }
    })

    clientReviewTl.fromTo('.block-client-reviews .vertical-slides', {y: 0}, {y: -scrollUpLimit})
  }
}

window.initClientReviewsScripts = () => {
  initClientReviewCarousel()
  initClientReviewVerticalSlider()
}
$(document).ready(() => {
  initClientReviewsScripts();

  $('.js--card-review-link').on('click', function(e) {
    e.preventDefault(); // Prevent default link behavior

    var url = $(this).data('href'); // Get the URL from data-href attribute

    window.open(url, '_blank');

  });
});
